export default "__VITE_ASSET__kxc3bolI__"